import { Col, Row } from "antd";
import BoxSectionItem from "../../../../../../../components/box-section/box-section-item";
import { DateHelper, StringHelper } from "../../../../../../../helper";
import { Moment } from "moment";
import { DateFormat } from "../../../../../../../constants";

interface Props {
  data: any;
}

export const AFLSuspendContractDetail = ({ data }: Props) => {
  const eVacationPeriodText = () => {
    return data?.eVacationPeriods
      .map((i: Moment[]) =>
        DateHelper.formatRangeDateToString(i, {
          format: DateFormat.DD_MM_YYYY_HH_MM,
        }),
      )
      .join(", ");
  };
  return (
    <Row gutter={[32, 0]}>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Họ và tên" textRight={data?.eRequestName} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Mã nhân viên" textRight={data?.eEmployeeId} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Chức danh" textRight={StringHelper.verticalBarSplit<string[]>(data?.eTeam)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Sinh ngày" textRight={DateHelper.formatDateToString(data?.eEmployeeBirthday)} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Cơ quan/Đơn vị" textRight={StringHelper.verticalBarSplit(data?.eDepartment)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Đơn vị" textRight={StringHelper.verticalBarSplit(data?.eUnit)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Đội/Nhóm" textRight={StringHelper.verticalBarSplit<string[]>(data?.eTeam)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Địa điểm thường trú" textRight={data?.eAddress} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Thời gian công tác tại cơ quan, chi nhánh" textRight={data?.eBusinessTime} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Code Sabre" textRight={data?.eCodeSabre} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Thời gian xin tạm hoãn" textRight={eVacationPeriodText()} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Thời gian tạm hoãn"
          textRight={DateHelper.duration(data?.eVacationPeriods).humanize()}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Lý do" textRight={data?.eReason} />
      </Col>
    </Row>
  );
};
